import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export type FaqAction = 'chat_with_us' | 'got_it' | 'faq_viewed';

export interface ChatWithUsClickPayload {
  sub_category_id: string;
  faq_question: string | null;
  action: FaqAction;
}

// Logs an action on the Support modal's FAQ step (one cc_uri_chat_handoff row):
// a "Chat with us" tap (keyed to the logged-in user's phone, so the WhatsApp
// chat that follows can be attributed to the picked category), a "Got it" tap,
// or the FAQ step being shown.
export default function useLogChatWithUsClick() {
  return useMutation(async (payload: ChatWithUsClickPayload) => {
    const response = await ChessRestClient.post(
      '/user_raised_issues/chat_with_us/',
      payload,
    );
    return response.data;
  });
}
